import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { VisualizationFilterGitService } from './visualization-filter-git.service';

@Injectable({ providedIn: 'root' })
export class VisualizationFilterGitFactoryService extends AbstractGitFactoryService<VisualizationFilterGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: VisualizationFilterGitService,
    });
  }
}
